import { useState, useEffect } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };
const STARS = ['அஸ்வினி','பரணி','கிருத்திகை','ரோகிணி','மிருகசீரிஷம்','திருவாதிரை','புனர்பூசம்','பூசம்','ஆயில்யம்','மகம்','பூரம்','உத்திரம்','அஸ்தம்','சித்திரை','சுவாதி','விசாகம்','அனுஷம்','கேட்டை','மூலம்','பூராடம்','உத்திராடம்','திருவோணம்','அவிட்டம்','சதயம்','பூரட்டாதி','உத்திரட்டாதி','ரேவதி'];
const DASA_LORDS = [{name:'சூரியன்',years:6},{name:'சந்திரன்',years:10},{name:'செவ்வாய்',years:7},{name:'ராகு',years:18},{name:'குரு',years:16},{name:'சனி',years:19},{name:'புதன்',years:17},{name:'கேது',years:7},{name:'சுக்ரன்',years:20}];
const DASA_ORDER = [0,1,2,3,4,5,6,7,8]; // Sun,Moon,Mars,Rahu,Jup,Sat,Mer,Ket,Ven
const STAR_DASA_START = [7,8,0,1,2,3,4,5,6, 7,8,0,1,2,3,4,5,6, 7,8,0,1,2,3,4,5,6];

const DasaBukthiPage = () => {
  const [star, setStar] = useState(0);
  const [dob, setDob] = useState('2000-01-01');

  const startIdx = STAR_DASA_START[star];
  const birthDate = new Date(dob);

  // Build dasa timeline
  const dasas = [];
  let d = new Date(birthDate);
  for (let i = 0; i < 9; i++) {
    const idx = (startIdx + i) % 9;
    const lord = DASA_LORDS[idx];
    const start = new Date(d);
    d = new Date(d.getTime() + lord.years * 365.25 * 24 * 3600 * 1000);
    dasas.push({ lord: lord.name, years: lord.years, start, end: new Date(d) });
  }

  const now = new Date();
  const fmt = dt => `${dt.getDate()}/${dt.getMonth()+1}/${dt.getFullYear()}`;

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>🔮 தசா புக்தி</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Dasa Bukthi Calculator</div>
      </div>
      <div style={{background:T.cream,padding:'10px',borderRadius:'8px',border:'1px solid '+T.border,marginBottom:'10px'}}>
        <div style={{marginBottom:'6px'}}>
          <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk}}>ஜன்ம நக்ஷத்ரம்</label>
          <select value={star} onChange={e=>setStar(parseInt(e.target.value))}
            style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc',fontWeight:700}}>
            {STARS.map((s,i)=><option key={i} value={i}>{i+1}. {s}</option>)}
          </select>
        </div>
        <div>
          <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk}}>பிறந்த தேதி</label>
          <input type="date" value={dob} onChange={e=>setDob(e.target.value)}
            style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc'}} />
        </div>
      </div>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.7rem'}}>
        <thead><tr style={{background:T.greenDk,color:'#fff'}}>
          <th style={{padding:'5px',border:'1px solid #ccc'}}>#</th>
          <th style={{padding:'5px',border:'1px solid #ccc'}}>தசா நாதன்</th>
          <th style={{padding:'5px',border:'1px solid #ccc'}}>ஆண்டுகள்</th>
          <th style={{padding:'5px',border:'1px solid #ccc'}}>ஆரம்பம்</th>
          <th style={{padding:'5px',border:'1px solid #ccc'}}>முடிவு</th>
        </tr></thead>
        <tbody>
          {dasas.map((ds,i) => {
            const isCurrent = now >= ds.start && now <= ds.end;
            return (
              <tr key={i} style={{background:isCurrent?'#e8f5e9':i%2?'#f5f5f5':'#fff',fontWeight:isCurrent?700:400}}>
                <td style={{padding:'4px',border:'1px solid #eee',textAlign:'center'}}>{i+1}</td>
                <td style={{padding:'4px',border:'1px solid #eee',color:isCurrent?T.greenDk:T.maroon,fontWeight:700}}>{isCurrent?'▶ ':''}{ds.lord}</td>
                <td style={{padding:'4px',border:'1px solid #eee',textAlign:'center'}}>{ds.years}</td>
                <td style={{padding:'4px',border:'1px solid #eee',fontSize:'0.6rem'}}>{fmt(ds.start)}</td>
                <td style={{padding:'4px',border:'1px solid #eee',fontSize:'0.6rem'}}>{fmt(ds.end)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div style={{fontSize:'0.6rem',color:T.maroon,background:'#fff3e0',padding:'6px',borderRadius:'6px',marginTop:'8px'}}>
        📌 தற்போதைய தசா பச்சை நிறத்தில் காட்டப்படும். முழு 120 ஆண்டு சுழற்சி.
      </div>
    </div>
  );
};
export default DasaBukthiPage;